module.exports = __webpack_public_path__ + "media/img/promotion-20dc98462ea4d3838c1fd6641aa9f53a.svg";